import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminAiComponent } from './admin-ai.component';

const routes: Routes = [
  {
    path: '',
    component: AdminAiComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminAiRoutingModule {}
